import { collection, getDocs, limit, query, where } from "firebase/firestore";
import { firestore } from "../firebase";

// ASCII-fold + hyphenate a display name into a URL-safe slug: "Bodø" -> "bodo".
export function slugify(name) {
  return (name || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // strip combining diacritics (é -> e)
    .replace(/ø/gi, "o")
    .replace(/æ/gi, "ae")
    .replace(/å/gi, "a")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Generates a slug for a new location/event that isn't already used by
// another `lokasjoner` doc, appending -2/-3/... on collision. This is meant
// to be called ONCE, at creation time, and the result stored permanently —
// never regenerate it on a later rename, or existing shared links break.
export async function generateUniqueSlug(name) {
  const base = slugify(name) || "sted";
  let candidate = base;
  let suffix = 2;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const snap = await getDocs(query(collection(firestore, "lokasjoner"), where("slug", "==", candidate), limit(1)));
    if (snap.empty) return candidate;
    candidate = `${base}-${suffix}`;
    suffix++;
  }
}
